/**
 * Staff backend base URL. The literal `process.env.PUBLIC_API_URL` is replaced
 * with a string at bundle time by Bun's `PUBLIC_*` env-inlining — `env:
 * 'PUBLIC_*'` in dev-server.js for the dev server, and in build.js for
 * production. The `PUBLIC_` prefix is the inlining allowlist (like Vite's
 * `VITE_`); only literal `process.env.PUBLIC_*` reads are replaced, so do not
 * destructure or alias it. Empty string means same-origin (not used here — the
 * SPA always talks to the API cross-origin).
 */
export function getBackendUrl() {
    return process.env.PUBLIC_API_URL || '';
}
